import {fetchSessionState} from './session_api_util';

// Reconcile a suspended tab with the server without reloading an active form
// for a normal focus event or treating a network outage as a sign-out.
export function installSessionRecovery(store, {window: win = window, document: doc = document, refresh = fetchSessionState} = {}) {
  let hiddenAt = null;
  let pending = false;
  const check = () => {
    if (doc.visibilityState === 'hidden' || hiddenAt === null || pending) return;
    hiddenAt = null;
    pending = true;
    const userId = store.getState().session.currentUser?.id || null;
    refresh().then(state => {
      // A full reload clears private Redux data if the account changed in
      // another tab, or restores a valid remembered session to a stale login.
      if ((store.getState().session.currentUser?.id || null) === userId && state.user_id !== userId) win.location.reload();
    }).catch(() => {}).then(() => { pending = false; });
  };
  const visibility = () => {
    if (doc.visibilityState === 'hidden') hiddenAt = Date.now();
    else check();
  };
  const restored = event => { if (event.persisted) {hiddenAt = Date.now(); check();} };
  doc.addEventListener('visibilitychange', visibility);
  win.addEventListener('pageshow', restored);
  return () => {
    doc.removeEventListener('visibilitychange', visibility);
    win.removeEventListener('pageshow', restored);
  };
}
